import $ from 'jquery'

try {
  window.$ = window.jQuery = $;

} catch (e) {}
